import api from './api'

export interface EstimateAsset {
  id: string
  estimateId: string
  tenantId: string
  url: string
  fileName: string
  category: string
  description: string | null
  sortOrder: number
  uploadedByUserId: string
  createdAt: string
  updatedAt: string
}

export const assetsService = {
  async list(estimateId: string) {
    const { data } = await api.get(`/estimates/${estimateId}/assets`)
    return data.data as EstimateAsset[]
  },

  async upload(estimateId: string, payload: { base64: string; fileName: string; category: string }) {
    const { data } = await api.post(`/estimates/${estimateId}/assets`, payload)
    return data.data as EstimateAsset
  },

  async update(estimateId: string, assetId: string, payload: { category?: string; description?: string | null; sortOrder?: number }) {
    const { data } = await api.put(`/estimates/${estimateId}/assets/${assetId}`, payload)
    return data.data as EstimateAsset
  },

  async remove(estimateId: string, assetId: string) {
    await api.delete(`/estimates/${estimateId}/assets/${assetId}`)
  },
}
